export const MAKE_REQUEST = "NOTIFICATION_MAKE_REQUEST";
export const FAIL_REQUEST = "NOTIFICATION_FAIL_REQUEST";
export const GET_NOTIFICATION_LIST = "GET_NOTIFICATION_LIST";
export const UPDATE_ISSUCCESS = "UPDATE_NOTIFICATION_ISSUCCESS";
